import React from 'react'
import BaseWidget from './BaseWidget'
import type { BaseWidgetProps } from './BaseWidget'

const SearchCard: React.VFC<BaseWidgetProps> = (props: BaseWidgetProps) => <BaseWidget {...props} />

export default SearchCard
export type { BaseWidgetProps as SearchCardProps }
